import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6a928fde"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "data-card" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "card-header" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "title" }, [
    /*#__PURE__*/_createTextVNode("当前告警 "),
    /*#__PURE__*/_createElementVNode("span", { class: "info-icon" }, "?")
  ]),
  /*#__PURE__*/_createElementVNode("a", {
    href: "/#/alarm/list",
    class: "view-more"
  }, "查看更多 >")
], -1))
const _hoisted_3 = { class: "card-body" }
const _hoisted_4 = { class: "total-alarms" }
const _hoisted_5 = { class: "count" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "label" }, "待处理数", -1))
const _hoisted_7 = { class: "legend-grid" }
const _hoisted_8 = { class: "legend-item" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "dot",
  style: {"background-color":"#56d396"}
}, null, -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label" }, "紧急", -1))
const _hoisted_11 = { class: "value" }
const _hoisted_12 = { class: "legend-item" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "dot",
  style: {"background-color":"#ff4d4f"}
}, null, -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label" }, "重要", -1))
const _hoisted_15 = { class: "value" }
const _hoisted_16 = { class: "legend-item" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "dot",
  style: {"background-color":"#ffc107"}
}, null, -1))
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label" }, "一般", -1))
const _hoisted_19 = { class: "value" }

import { ref, computed, onMounted, onUnmounted, watch } from 'vue'
import * as echarts from 'echarts'
interface StatusData {
  urgent: number
  important: number
  general: number
}


export default /*#__PURE__*/_defineComponent({
  props: {
    statusData: null
  },
  setup(__props: any) {

const props = __props as {
  statusData: StatusData
}



const total = computed(
  () => props.statusData.urgent + props.statusData.important + props.statusData.general,
)

const normalRate = computed(() => {
  if (total.value === 0) return 0
  return Math.round((props.statusData.urgent / total.value) * 100)
})
const chart = ref()
onMounted(() => {
  // 添加视图变化监听重新渲染图表
  window.addEventListener('resize', () => {
    if (chart.value) {
      const chartInstance = echarts.getInstanceByDom(chart.value)
      if (chartInstance) {
        chartInstance.resize()
      }
    }
  })
  if (chart.value) {
    const chartInstance = echarts.init(chart.value)
    chartInstance.setOption(chartOption.value)
  }
})
onUnmounted(() => {
  // 清理事件监听
  window.removeEventListener('resize', () => {
    if (chart.value) {
      const chartInstance = echarts.getInstanceByDom(chart.value)
      if (chartInstance) {
        chartInstance.resize()
      }
    }
  })
})

const chartOption = computed(() => ({
  title: {
    text: `${normalRate.value}%`,
    subtext: '正常运行率',
    left: 'center',
    top: '38%',
    textStyle: {
      fontSize: 28,
      color: '#6563ff',
      fontWeight: 'bold',
    },
    subtextStyle: {
      fontSize: 14,
      color: '#909399',
    },
  },
  series: [
    {
      type: 'pie',
      radius: ['75%', '90%'],
      avoidLabelOverlap: false,
      hoverAnimation: false,
      label: {
        show: false,
      },
      data: [
        {
          value: props.statusData.normal,
          itemStyle: {
            color: '#6563ff', // 正常部分颜色
          },
        },
        {
          value: total.value - props.statusData.normal,
          itemStyle: {
            color: '#eef2f8', // 背景环颜色
          },
        },
      ],
    },
  ],
}))

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, _toDisplayString(_unref(total)), 1),
        _hoisted_6
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", _hoisted_8, [
          _hoisted_9,
          _hoisted_10,
          _createElementVNode("span", _hoisted_11, _toDisplayString(__props.statusData.urgent), 1)
        ]),
        _createElementVNode("div", _hoisted_12, [
          _hoisted_13,
          _hoisted_14,
          _createElementVNode("span", _hoisted_15, _toDisplayString(__props.statusData.important), 1)
        ]),
        _createElementVNode("div", _hoisted_16, [
          _hoisted_17,
          _hoisted_18,
          _createElementVNode("span", _hoisted_19, _toDisplayString(__props.statusData.general), 1)
        ])
      ])
    ])
  ]))
}
}

})